import { CarForm } from './pages/CarForm';
import { useTelegram } from './hooks/useTelegram';
import { useEffect } from 'react';

function App() {
  const { tg, isReady } = useTelegram();

  useEffect(() => {
    if (tg) {
      tg.ready();
      tg.expand();
      tg.enableClosingConfirmation();
    }
  }, [tg]);

  if (!isReady) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  return <CarForm />;
}

export default App;
